"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _react2 = require("motion/react");
var _bodyScrollLock = require("body-scroll-lock");
var _styles = require("./styles");
var _IconClose = _interopRequireDefault(require("../../icons/General/IconClose"));
var _ = require("../..");
var _IconMinus = _interopRequireDefault(require("../../icons/General/IconMinus"));
var _IconFullscreenOpen = _interopRequireDefault(require("../../icons/General/IconFullscreenOpen"));
var _ActionButtons = _interopRequireDefault(require("./ActionButtons"));
var _jsxRuntime = require("@emotion/react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/** @jsxImportSource @emotion/react */

function Modal({
  open,
  header,
  actionButton,
  width = '480px',
  children,
  disableOutsideClick = true,
  hideCloseButton,
  disableScroll = true,
  disableRefFocus,
  targetRefs,
  disableScrollableContent,
  headerCss,
  contentCss,
  disableLocalClose,
  toggleFullscreen,
  defaultFullscreen,
  disableFocusTrap,
  onClose,
  onCollapse,
  onFullscreenToggle,
  ...restProps
}) {
  const modalRef = /*#__PURE__*/(0, _react.createRef)();
  const [isOpen, setOpen] = (0, _react.useState)(open);
  const [headerHeight, setHeaderHeight] = (0, _react.useState)(0);
  const [isFullscreen, setIsFullscreen] = (0, _react.useState)(!!defaultFullscreen);
  const hasCollapse = Boolean(onCollapse);
  const headerText = header && header?.props?.children || '';
  const setClose = () => {
    (0, _bodyScrollLock.enableBodyScroll)(modalRef.current);
    if (!disableLocalClose) setOpen(false);
    if (onClose) {
      onClose();
    }
  };
  const handleToggleFullscreen = () => {
    const newValue = !isFullscreen;
    setIsFullscreen(newValue);
    onFullscreenToggle && onFullscreenToggle(newValue);
  };

  // Capture escape
  const handleKeyDown = (0, _react.useCallback)(event => {
    if (event.key === 'Escape') {
      setClose();
    }
  }, [setClose]);
  const handleHeaderRef = (0, _react.useCallback)(node => {
    setHeaderHeight(node?.clientHeight);
  }, []);
  (0, _react.useEffect)(() => {
    if (!modalRef.current) return;
    if (isOpen && !disableRefFocus) {
      modalRef.current.focus();
    }
    if (isOpen && disableScroll) {
      (0, _bodyScrollLock.disableBodyScroll)(modalRef.current);
      if (targetRefs && targetRefs.length > 0) {
        targetRefs.forEach(ref => (0, _bodyScrollLock.disableBodyScroll)(ref.current));
      }
      return;
    }
    (0, _bodyScrollLock.enableBodyScroll)(modalRef.current);
  }, [isOpen, modalRef, open, targetRefs, disableScroll]);

  /** Cleanup body scroll on component destroyed */
  (0, _react.useEffect)(() => {
    return () => {
      (0, _bodyScrollLock.clearAllBodyScrollLocks)();
    };
  });
  (0, _react.useEffect)(() => {
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  });
  const onOutsideClick = () => {
    if (disableOutsideClick) return;
    setClose();
  };
  return (0, _jsxRuntime.jsx)(_react2.AnimatePresence, {
    children: isOpen && (0, _jsxRuntime.jsx)(_styles.Overlay, {
      onClick: onOutsideClick,
      initial: {
        opacity: 0
      },
      animate: {
        opacity: 1
      },
      exit: {
        opacity: 0
      },
      transition: {
        duration: 0.1
      },
      children: (0, _jsxRuntime.jsxs)(_styles.Content, {
        open: isOpen,
        "aria-modal": "true",
        "aria-label": restProps['aria-label'] ?? header ? headerText.toString() : 'Modal',
        width: width,
        isFullscreen: isFullscreen,
        canToggleFullscreen: !!toggleFullscreen,
        onClick: e => e.stopPropagation(),
        ...restProps,
        children: [(!hideCloseButton || hasCollapse || toggleFullscreen) && (0, _jsxRuntime.jsxs)(_styles.CloseWrapper, {
          children: [hasCollapse && (0, _jsxRuntime.jsx)(_.Button, {
            nostyle: true,
            onClick: onCollapse,
            focusable: true,
            "aria-label": hasCollapse && 'Minimer',
            title: "Minimer",
            children: (0, _jsxRuntime.jsx)(_IconMinus.default, {})
          }), toggleFullscreen && (0, _jsxRuntime.jsx)(_.Button, {
            nostyle: true,
            onClick: handleToggleFullscreen,
            focusable: true,
            "aria-label": isFullscreen ? 'Lukk fullskjerm' : 'Fullskjerm',
            title: isFullscreen ? 'Lukk fullskjerm' : 'Fullskjerm',
            children: isFullscreen ? (0, _jsxRuntime.jsx)(_.IconFullscreenClose, {
              size: "20px"
            }) : (0, _jsxRuntime.jsx)(_IconFullscreenOpen.default, {
              size: "20px"
            })
          }), !hideCloseButton && (0, _jsxRuntime.jsx)(_.Button, {
            nostyle: true,
            onClick: setClose,
            focusable: true,
            "aria-label": "Lukk",
            title: "Lukk",
            children: (0, _jsxRuntime.jsx)(_IconClose.default, {})
          })]
        }), (0, _jsxRuntime.jsx)(_styles.HeaderWrapper, {
          css: headerCss,
          withCollapse: hasCollapse,
          ref: handleHeaderRef,
          children: header && header
        }), (0, _jsxRuntime.jsx)(_styles.ModalContent, {
          css: contentCss,
          scrollable: !disableScrollableContent,
          ref: disableScrollableContent ? modalRef : undefined,
          children: disableScrollableContent ? children : (0, _jsxRuntime.jsx)(_styles.ScrollableDiv, {
            ref: modalRef,
            hasActionButton: !!actionButton,
            isFullscreen: isFullscreen,
            windowHeight: window.innerHeight,
            headerHeight: headerHeight,
            children: children
          })
        }), actionButton && (0, _jsxRuntime.jsx)(_styles.ActionButtonWrapper, {
          children: actionButton
        })]
      })
    })
  });
}
Modal.Actions = _ActionButtons.default;
var _default = exports.default = Modal;